import AppWrapper from '../../layout/AppWrapper';
import Title from '../../utils/Title';
import { useWebSocketContext } from '../../context/web_socket_context';
import { useEffect } from 'react';

const Notifications = () => {


      // const { usertoken, btoken, stoken } = useUserContext();
      const { notifications, setNotificationBadge } = useWebSocketContext();

      // console.log(notifications);

      useEffect(() => {
            // Example: clear badge on dropdown open
            setNotificationBadge(false);
      }, []);

      return (

            <AppWrapper
                  pagename={"dashboard"}
            >
                  <Title title={"Notifications"} />

                  <div>
                        {notifications && notifications.length > 0 ? (
                              <ul>
                                    {notifications.map((note, idx) => (
                                          <>
                                                <li key={idx} className='mb-3 border-bottom'>
                                                      {/* Render based on your structure */}
                                                      <p className="m-0 fw-bold">
                                                            {note?.title}
                                                      </p>
                                                      <p className='m-0 small'>{note?.message}</p>
                                                      <p className='small grey-light-text'>{new Date(note.time * 1000).toLocaleString()}</p>
                                                </li>
                                          </>
                                    )).reverse()
                                    }
                              </ul>
                        ) : (
                              <p>No notifications yet.</p>
                        )}
                  </div>
            </AppWrapper>
      );
};

export default Notifications;